export default "__VITE_ASSET__CbgK5gzH__"